var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCertificate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#869898FF",
    d: "M13.586 2A2 2 0 0 1 15 2.586L19.414 7A2 2 0 0 1 20 8.414V20a2 2 0 0 1-2 2h-5a1 1 0 1 1 0-2h5V10h-4.5A1.5 1.5 0 0 1 12 8.5V4H6v4a1 1 0 0 1-2 0V4a2 2 0 0 1 2-2h7.586ZM7 10a4 4 0 0 1 3 6.646v4.192a1.1 1.1 0 0 1-1.592.984L7 21.118l-1.408.704A1.1 1.1 0 0 1 4 20.838v-4.192A4 4 0 0 1 7 10Zm1 7.874a4.01 4.01 0 0 1-2 0v1.508l.553-.276a1 1 0 0 1 .894 0l.553.276v-1.508ZM7 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm7-7.586V8h3.586L14 4.414Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCertificate);
export default __webpack_public_path__ + "static/media/Ic_certificate.62a2fd294ac2bf3ac123bc49976506d9.svg";
export { ForwardRef as ReactComponent };